module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAArBAMAAADrk5cEAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAADBQTFRFAAAAmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZsvyjQQAAABB0Uk5TABF3u5lEzP/u3TOIZiKqVaW4NSkAAAC+SURBVHicY2BUNoYCkwAGEBArh4MisIA7QqDcASTQPpEBAsyr2sFKyjfABApWlB8ACSjABbjaa1AFGMBKkAXASpAFwEpQBLjaa5EESkNDQ7fXIASeQ10LF/iOLsCrBATuSAJgEE62wNJQMAiECfAiQgwiwIguwHAVoiWAeFsY29HMwLCF4ZASGCiS4PTHkNi2hwlwYRjqDFFhRUkAkSrwAE0gvToUAWLSq6BRCgcGDDztyPw6AQYGViQtoRcYAE2iiSEJPj2oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_document.png
// module id = pvgg
// module chunks = 0